<div>
  <h3>Address</h3>
  <table>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>Title</mat-label>
          <input [(ngModel)]="composition.address.title" matInput>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-label>Street</mat-label>
          <input [(ngModel)]="composition.address.street" matInput>
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>ZIP</mat-label>
          <input [(ngModel)]="composition.address.zip" matInput type="number">
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-label>City</mat-label>
          <input [(ngModel)]="composition.address.city" matInput>
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>Phone label</mat-label>
          <input [(ngModel)]="composition.address.phoneLabel" matInput>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-label>Phone</mat-label>
          <input [(ngModel)]="composition.address.phone" matInput type="tel">
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>Fax</mat-label>
          <input [(ngModel)]="composition.address.fax" matInput>
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-label>E-Mail</mat-label>
          <input [(ngModel)]="composition.address.email" matInput type="email">
        </mat-form-field>
      </td>
    </tr>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>Website</mat-label>
          <input [(ngModel)]="composition.address.website" matInput type="url">
        </mat-form-field>
      </td>
    </tr>
  </table>
</div>

<div>
  <h3>App</h3>
  <table>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>App Title</mat-label>
          <input [(ngModel)]="composition.address.appTitle" matInput>
        </mat-form-field>
      </td>
    </tr>
  </table>
</div>

<div>
  <h3>Location</h3>
  <table>
    <tr>
      <td>
        <mat-form-field>
          <mat-label>Latitude</mat-label>
          <input [(ngModel)]="composition.location.coordinates[0]" matInput type="number">
        </mat-form-field>
      </td>
      <td>
        <mat-form-field>
          <mat-label>Longitude</mat-label>
          <input [(ngModel)]="composition.location.coordinates[1]" matInput type="number">
        </mat-form-field>
      </td>
    </tr>
  </table>
</div>
